/* eslint-disable @typescript-eslint/no-explicit-any */
import { createI18n, type I18nOptions } from 'vue-i18n'
import * as fusionLocales from '@fusion/saas-components-v3/locale'
import * as vuetifyLocales from 'vuetify/locale'

function loadLocaleMessages(): I18nOptions['messages'] {
  const messages: I18nOptions['messages'] = {}
  const appModules = import.meta.glob('../locales/*.json', { eager: true })

  for (const [path, module] of Object.entries(appModules)) {
    const locale = path.split('/').pop()?.slice(0, -5)
    if (!locale) continue
    const appLocale = (module as any).default ?? module
    const fusionLocale = (fusionLocales as any)[locale] ?? {}
    const vuetifyLocale = (vuetifyLocales as any)[locale] ?? {}

    messages[locale] = {
      ...fusionLocale,
      ...appLocale,
      $vuetify: {
        ...vuetifyLocale,
        ...fusionLocale.$vuetify,
        ...appLocale.$vuetify
      }
    }
  }

  return messages
}

export const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
  legacy: false,
  globalInjection: true
})
